module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/WOwgxt/tc-custom/9781609251734.jpg?1728727169028",
      "alt": "This image is the cover for the book Be Who You Want to Be"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Be Who You Want to Be\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A teenage girl’s guide to handling life’s problems, from how to be a better friend to dealing with parents and school.")]), _c('br'), _c('br'), _c('i', [_vm._v("Be Who You Want to Be")]), _vm._v(". Learn more about yourself and who you are and what makes you sad or made or happy. What do you like to do? What do you have to do? And how come some days are just so darned hard to get through? Sometimes it feels as if we just aren’t smart enough to succeed, nice enough to be likes, or pretty enough for anything."), _c('br'), _c('br'), _vm._v("Karen Casey has written helpful books especially for women and girls of all ages. She’s written this one because she remembers what it feels like to grow up. Think of this book as your toolkit with ideas for how to handle problems with friends, parents, school. Keep this book in a special place. It’s like having a friend to talk to any time you want.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Karen Casey\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Conari Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0